import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toError } from 'shared/util/toError';
import { callApi } from 'apiClient';
import { State } from 'reducers';
import { protocolsFailure, protocolsSuccess, protocolsRequest, protocolsReload } from 'actions/protocolActions';
import { BuildingId } from 'shared/models';

export type Options = {
    forceReload?: boolean;
    buildingId?: BuildingId;
};

export function useProtocols(options: Options = {}) {
    const {
        forceReload = false,
        buildingId,
    } = options;

    const { data, errorKey, loading, nextFetch } = useSelector((state: State) => state.protocols);
    const dispatch = useDispatch();

    useEffect(() => {
        if ((!loading && !errorKey && !data) || nextFetch < Date.now()) {
            dispatch(protocolsRequest());
            void (async () => {
                try {
                    const protocols = buildingId
                        ? await callApi('GET', `/api/buildings/${buildingId}/protocols`)
                        : await callApi('GET', `/api/protocols`);
                    dispatch(protocolsSuccess(protocols));
                }
                catch (e) {
                    const err = toError(e);
                    dispatch(protocolsFailure(err));
                }
            })();
        }
    }, [ data, loading, errorKey, nextFetch, dispatch, buildingId ]);

    useEffect(() => {
        if (forceReload) {
            dispatch(protocolsReload());
        }
    }, [ forceReload, dispatch ]);

    return {
        protocols: data,
        isLoadingProtocols: loading,
        errorKey,
    };
}
